module.exports = __webpack_public_path__ + "static/media/refund-fail.9040ef04.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/refund/refund-fail.png
// module id = 2106
// module chunks = 4